import { invokeApi } from "../../bl_libs/invokeApi";

export const member_init_without_token = async (data) => {
  const requestObj = {
    // path: `api/member_init/without_token`,
    path: `api/coach/init/without_token`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const member_init_with_token_api = async () => {
  const requestObj = {
    path: `api/member_init/with_token`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
